import { MobileDateRangePicker } from '@mui/lab';
import { Box, FormControl, styled } from '@mui/material';
import { Controller } from 'react-hook-form';

import Input from './Input';
import { type ControlledDateRangeProps } from './types';

const Separator = styled(Box)`
    margin: auto 1rem;
    padding-top: 1.5rem;
`;

export const ControlledDateRange = (props: ControlledDateRangeProps) => {
    const { name, control, defaultValue, calendars, startLabel, endLabel, separator } = props;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState }) => (
                <MobileDateRangePicker
                    label="Advanced keyboard"
                    {...field}
                    calendars={calendars}
                    renderInput={(startProps, endProps) => (
                        <>
                            <FormControl fullWidth>
                                <Input
                                    data-testid="start-date"
                                    label={startLabel}
                                    name={name}
                                    errorMessage={fieldState.error?.message}
                                    ref={startProps.inputRef as React.Ref<HTMLInputElement>}
                                    inputProps={startProps.inputProps}
                                    fullWidth
                                />
                            </FormControl>

                            <Separator>{separator}</Separator>

                            <FormControl fullWidth>
                                <Input
                                    data-testid="end-date"
                                    label={endLabel}
                                    name={name}
                                    errorMessage={fieldState.error?.message}
                                    ref={endProps.inputRef as React.Ref<HTMLInputElement>}
                                    inputProps={endProps.inputProps}
                                    fullWidth
                                />
                            </FormControl>
                        </>
                    )}
                />
            )}
        />
    );
};

export default ControlledDateRange;
